import React from 'react';
import { Button } from './ui';

export function useReplyEmailNotificationPrompt() {
  const [open, setOpen] = React.useState(false);
  const resolverRef = React.useRef<((value: boolean) => void) | null>(null);

  const ask = React.useCallback(() => {
    return new Promise<boolean>((resolve) => {
      resolverRef.current?.(false);
      resolverRef.current = resolve;
      setOpen(true);
    });
  }, []);

  const respond = React.useCallback((value: boolean) => {
    resolverRef.current?.(value);
    resolverRef.current = null;
    setOpen(false);
  }, []);

  React.useEffect(() => {
    return () => {
      resolverRef.current?.(false);
      resolverRef.current = null;
    };
  }, []);

  const prompt = open ? (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-zinc-950/30 px-4">
      <div className="w-full max-w-sm rounded-2xl border border-zinc-200 bg-white p-4 shadow-xl">
        <div className="text-sm font-semibold text-zinc-900">
          Do you want to be notified by email of replies to this topic?
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <Button variant="ghost" onClick={() => respond(false)}>
            No
          </Button>
          <Button onClick={() => respond(true)}>Yes</Button>
        </div>
      </div>
    </div>
  ) : null;

  return { askReplyEmailNotification: ask, replyEmailNotificationPrompt: prompt };
}
